import * as React from 'react';
import { Box, Chip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ItemType, SelectedItemsListProps, getIconForType } from './types';

export const SelectedItemsList = ({ items, onRemove, type }: SelectedItemsListProps) => {
	if (items.length === 0) return null;

	return (
		<Box sx={{ mb: 1, display: 'flex', flexWrap: 'wrap', gap: 1 }}>
			{items.map(item => {
				const Icon = getIconForType(type ?? ItemType.FILE);
				return (
					<Chip
						key={item.id}
						label={item.name}
						onDelete={() => onRemove(item.id)}
						deleteIcon={<CloseIcon />}
						icon={<Icon />}
						variant='outlined'
						color='primary'
					/>
				);
			})}
		</Box>
	);
};
